export default "__VITE_ASSET__CREjW4qg__"